import { render, staticRenderFns } from "./GradeTip.vue?vue&type=template&id=f3a062ea&scoped=true&lang=pug&"
import script from "./GradeTip.vue?vue&type=script&lang=ts&"
export * from "./GradeTip.vue?vue&type=script&lang=ts&"
import style0 from "./GradeTip.vue?vue&type=style&index=0&id=f3a062ea&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a062ea",
  null
  
)

export default component.exports